import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, exhaustMap, map, of } from 'rxjs';
import { setLoadingSpinner } from '../actions/shared.action';
import * as fromAddressActions from '../actions/address.action';
import { AppState } from '../app.state';
import { AddressService } from 'src/app/services/address.service';

@Injectable()
export class AddressEffects {

  getRegions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromAddressActions.getRegions),
      exhaustMap(() =>
        this.addressService.getRegions().pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return fromAddressActions.getRegionsSuccess({ data: response?.details ?? response });
          }),
          catchError((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return of(fromAddressActions.getRegionsFailed({ data: response?.error?.message }));
          })
        )
      )
    )
  );

  getProvinces$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromAddressActions.getProvinces),
      exhaustMap((action) =>
        this.addressService.getProvinces(action.regionId).pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return fromAddressActions.getProvincesSuccess({ data: response?.details ?? response });
          }),
          catchError((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return of(fromAddressActions.getProvincesFailed({ data: response?.error?.message }));
          })
        )
      )
    )
  );

  getCities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromAddressActions.getCities),
      exhaustMap((action) =>
        this.addressService.getCities(action.provinceId).pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return fromAddressActions.getCitiesSuccess({ data: response?.details ?? response });
          }),
          catchError((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return of(fromAddressActions.getCitiesFailed({ data: response?.error?.message }));
          })
        )
      )
    )
  );

  getBarangays$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromAddressActions.getBarangays),
      exhaustMap((action) =>
        this.addressService.getBarangays(action.cityId).pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return fromAddressActions.getBarangaysSuccess({ data: response?.details ?? response });
          }),
          catchError((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return of(fromAddressActions.getBarangaysFailed({ data: response?.error?.message }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private addressService: AddressService,
    private store: Store<AppState>
  ) { }

}
